import { __assign, __extends, __rest } from "tslib";
import * as React from "react";
import { View, TextInput as NativeTextInput, StyleSheet, I18nManager, Platform, Text, Image } from "react-native";
import color from "color";
import InputLabel from "./Label/InputLabel";
import LabelBackground from "./Label/LabelBackground";
import { MAXIMIZED_LABEL_FONT_SIZE, MINIMIZED_LABEL_FONT_SIZE, LABEL_WIGGLE_X_OFFSET } from "./constants";
import configureFonts from "../styles/fonts";
import { calculateLabelTopPosition, calculateInputHeight, calculatePadding, adjustPaddingOut, Padding, interpolatePlaceholder } from "./helpers";
import { textStyle } from "../v2/theme";
var OUTLINE_MINIMIZED_LABEL_Y_OFFSET = -6;
var LABEL_PADDING_TOP = 8;
var MIN_HEIGHT = 52;
var MIN_DENSE_HEIGHT = 48;
var INPUT_PADDING_HORIZONTAL = 14;
var fonts = configureFonts();
var PnmacTextInputOutlined = /** @class */function (_super) {
  __extends(PnmacTextInputOutlined, _super);
  function PnmacTextInputOutlined() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PnmacTextInputOutlined.prototype.render = function () {
    var _a = this.props,
      disabledColored = _a.disabledColored,
      disabled = _a.disabled,
      editable = _a.editable,
      selectTextOnFocus = _a.selectTextOnFocus,
      label = _a.label,
      error = _a.error,
      selectionColor = _a.selectionColor,
      underlineColor = _a.underlineColor,
      dense = _a.dense,
      style = _a.style,
      theme = _a.theme,
      render = _a.render,
      multiline = _a.multiline,
      parentState = _a.parentState,
      innerRef = _a.innerRef,
      onFocus = _a.onFocus,
      payment = _a.payment,
      onBlur = _a.onBlur,
      onChangeText = _a.onChangeText,
      onLayoutAnimatedText = _a.onLayoutAnimatedText,
      bold = _a.bold,
      textAlign = _a.textAlign,
      renderRightIcon = _a.renderRightIcon,
      isValid = _a.isValid,
      rest = __rest(_a, ["disabledColored", "disabled", "editable", "selectTextOnFocus", "label", "error", "selectionColor", "underlineColor", "dense", "style", "theme", "render", "multiline", "parentState", "innerRef", "onFocus", "payment", "onBlur", "onChangeText", "onLayoutAnimatedText", "bold", "textAlign", "renderRightIcon", "isValid"]);
    var font = fonts.regular;
    var hasActiveOutline = parentState.focused || error;
    var _b = StyleSheet.flatten(style) || {},
      fontSizeStyle = _b.fontSize,
      fontWeight = _b.fontWeight,
      height = _b.height,
      _c = _b.backgroundColor,
      backgroundColor = _c === void 0 ? "#F2F2F2" : _c,
      viewStyle = __rest(_b, ["fontSize", "fontWeight", "height", "backgroundColor"]);
    var fontSize = fontSizeStyle || MAXIMIZED_LABEL_FONT_SIZE;
    var inputTextColor, activeColor, outlineColor, placeholderColor, errorColor;
    if (disabled) {
      inputTextColor = activeColor = color("#1B1B1B").alpha(0.54).rgb().string();
      placeholderColor = outlineColor = payment ? payment.color : color('#bdbdbd').alpha(0.26).rgb().string();
    } else {
      inputTextColor = "#1B1B1B";
      activeColor = error ? "#FC5350" : "#1B1B1B";
      placeholderColor = outlineColor = "#595959";
      errorColor = "#FC5350";
    }
    if (disabledColored) {
      inputTextColor = activeColor = "#1B1B1B";
      placeholderColor = outlineColor = payment ? payment.color : color('#000000').alpha(0.54).rgb().string();
    }
    if (isValid) {
      activeColor = "#59AB6B";
      outlineColor = "#59AB6B";
    }
    var labelScale = MINIMIZED_LABEL_FONT_SIZE / fontSize;
    var fontScale = MAXIMIZED_LABEL_FONT_SIZE / fontSize;
    var labelWidth = parentState.labelLayout.width;
    var labelHeight = parentState.labelLayout.height;
    var labelHalfWidth = labelWidth / 2;
    var labelHalfHeight = labelHeight / 2;
    var baseLabelTranslateX = (I18nManager.isRTL ? 1 : -1) * (labelHalfWidth - labelScale * labelWidth / 2 - (fontSize - MINIMIZED_LABEL_FONT_SIZE) * labelScale);
    var minInputHeight = (dense ? MIN_DENSE_HEIGHT : MIN_HEIGHT) - LABEL_PADDING_TOP;
    var inputHeight = calculateInputHeight(labelHeight, height, minInputHeight);
    var topPosition = calculateLabelTopPosition(labelHeight, inputHeight, LABEL_PADDING_TOP);
    if (height && typeof height !== "number") console.warn("Currently we support only numbers in height prop");
    var paddingSettings = {
      height: height ? +height : null,
      labelHalfHeight: labelHalfHeight,
      offset: LABEL_PADDING_TOP,
      multiline: multiline ? multiline : null,
      dense: dense ? dense : null,
      topPosition: topPosition,
      fontSize: fontSize,
      label: label,
      scale: fontScale,
      isAndroid: Platform.OS === "android",
      styles: StyleSheet.flatten(dense ? styles.inputOutlinedDense : styles.inputOutlined)
    };
    var pad = calculatePadding(paddingSettings);
    var paddingOut = adjustPaddingOut(__assign(__assign({}, paddingSettings), {
      pad: pad
    }));
    var baseLabelTranslateY = -labelHalfHeight - (topPosition + OUTLINE_MINIMIZED_LABEL_Y_OFFSET);
    var placeholderOpacity = interpolatePlaceholder(parentState.labeled, hasActiveOutline);
    var labelProps = {
      label: label,
      onLayoutAnimatedText: onLayoutAnimatedText,
      placeholderOpacity: placeholderOpacity,
      error: error,
      placeholderStyle: styles.placeholder,
      baseLabelTranslateY: baseLabelTranslateY,
      baseLabelTranslateX: baseLabelTranslateX,
      font: font,
      fontSize: fontSize,
      fontWeight: fontWeight,
      labelScale: labelScale,
      wiggleOffsetX: LABEL_WIGGLE_X_OFFSET,
      topPosition: topPosition,
      hasActiveOutline: hasActiveOutline,
      activeColor: activeColor,
      placeholderColor: placeholderColor,
      backgroundColor: backgroundColor,
      errorColor: errorColor
    };
    var minHeight = height || (dense ? MIN_DENSE_HEIGHT : MIN_HEIGHT);
    return /*#__PURE__*/React.createElement(View, {
      style: viewStyle,
      nativeID: rest.idTag1
    }, /*#__PURE__*/React.createElement(View, {
      nativeID: rest.idTag2
    }, /*#__PURE__*/React.createElement(Outline, {
      disabled: disabled,
      theme: theme,
      hasActiveOutline: hasActiveOutline,
      activeColor: activeColor,
      outlineColor: outlineColor,
      backgroundColor: backgroundColor,
      nativeID: rest.idTag3
    }), /*#__PURE__*/React.createElement(View, {
      style: renderRightIcon ? {
        minHeight: minHeight,
        flexDirection: "row",
        alignItems: "center"
      } : {
        minHeight: minHeight
      },
      nativeID: rest.idTag4
    }, render === null || render === void 0 ? void 0 : render(__assign(__assign({}, rest), {
      ref: innerRef,
      onChangeText: onChangeText,
      placeholder: label ? parentState.placeholder : this.props.placeholder,
      placeholderTextColor: placeholderColor,
      editable: !disabled && editable,
      selectTextOnFocus: selectTextOnFocus,
      selectionColor: typeof selectionColor === "undefined" ? activeColor : selectionColor,
      onFocus: onFocus,
      onBlur: onBlur,
      underlineColorAndroid: "transparent",
      multiline: multiline,
      style: [styles.input, !multiline || multiline && height ? {
        height: inputHeight
      } : {}, paddingOut, Platform.select({
        web: __assign(__assign({}, bold ? textStyle.formBodyTotal : textStyle.formTextInput), {
          outline: "none",
          color: inputTextColor,
          textAlignVertical: multiline ? "top" : "center"
        }),
        ios: __assign(__assign({}, bold ? textStyle.formBodyTotal : textStyle.formTextInput), {
          color: inputTextColor,
          textAlignVertical: multiline ? "top" : "center"
        }),
        android: __assign(__assign({}, bold ? textStyle.formBodyTotal : textStyle.formTextInput), {
          color: inputTextColor,
          textAlignVertical: multiline ? "top" : "center"
        })
      }), {
        textAlign: textAlign || "right"
      }, renderRightIcon && {
        flex: 1,
        paddingRight: 20
      }]
    })), renderRightIcon && (error || isValid) && /*#__PURE__*/React.createElement(View, {
      style: {
        width: 20,
        height: 20,
        marginRight: 10
      }
    }, /*#__PURE__*/React.createElement(Image, {
      style: {
        width: 20,
        height: 20
      },
      resizeMode: "contain",
      source: error ? require('../assets/validationError.png') : require('../assets/validationSuccess.png')
    })))), !!error && /*#__PURE__*/React.createElement(Text, {
      style: __assign(__assign({
        marginTop: 5
      }, textStyle.defaultTextDescription), {
        color: errorColor
      })
    }, this.props.label));
  };
  PnmacTextInputOutlined.defaultProps = {
    disabled: false,
    disabledColored: false,
    error: false,
    multiline: false,
    editable: true,
    renderRightIcon: false,
    render: function (props) {
      return /*#__PURE__*/React.createElement(NativeTextInput, __assign({
        nativeID: "disable-select"
      }, props));
    }
  };
  return PnmacTextInputOutlined;
}(React.Component);
export default /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(PnmacTextInputOutlined, __assign({
    innerRef: ref
  }, props));
});
var Outline = function (_a) {
  var theme = _a.theme,
    disabled = _a.disabled,
    hasActiveOutline = _a.hasActiveOutline,
    activeColor = _a.activeColor,
    outlineColor = _a.outlineColor,
    backgroundColor = _a.backgroundColor;
  return /*#__PURE__*/React.createElement(View, {
    pointerEvents: "none",
    style: [styles.outline, {
      backgroundColor: disabled ? '#eee' : '#FFF',
      borderRadius: 10,
      borderWidth: 1,
      borderColor: hasActiveOutline ? activeColor : outlineColor
    }]
  });
};
var styles = StyleSheet.create({
  placeholder: {
    position: "absolute",
    left: 4,
    paddingHorizontal: INPUT_PADDING_HORIZONTAL
  },
  outline: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  },
  input: {
    flexGrow: 1,
    paddingHorizontal: INPUT_PADDING_HORIZONTAL,
    margin: 0,
    textAlign: "right",
    zIndex: 1
  },
  inputOutlined: {
    paddingTop: 8,
    paddingBottom: 8
  },
  inputOutlinedDense: {
    paddingTop: 4,
    paddingBottom: 4
  }
});